import Client from '../axiosClient'
const resource = '/support';
const resourceInit = 'support_initialize';
const resourceUpdateStatus = 'support_status_update';
const resourceMail = 'send_mail_to_subscribed_user';
export default {
    init() {
      return Client.get(`${resourceInit}`);
    },
    get(payload) {
      let filterParam='';
      if(payload) {
        console.log('Join Us Repository:',payload);
        let filterParam = 'requestFrom='+payload['requestFrom'];
        this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}`;
        return Client.get(`${resourceInit}?${this.filterParam}`);
      //  return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
      }
      return Client.get(`${resource}`);
  
    },
  
    getById(id) {
      return Client.get(`${resource}/${id}`);
    },
  
    post(payload) {
      return Client.post(`${resource}`, payload);
    },
    
    updateStatus(payload) {
      return Client.post(`${resourceUpdateStatus}`, payload);
    },

    sendMail(payload) {
      return Client.post(`${resourceMail}`, payload);
    }

  };


// WEBPACK FOOTER //
// ./src/repositories/events/supportRepository.js